/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientCreate,
  ClientUpdate,
  DeviceCreate,
  DeviceUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    ClientCreateFromJSON,
    ClientCreateToJSON,
    ClientUpdateFromJSON,
    ClientUpdateToJSON,
    DeviceCreateFromJSON,
    DeviceCreateToJSON,
    DeviceUpdateFromJSON,
    DeviceUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface ApiAddClientV2V2ClientPostRequest {
    clientCreate: ClientCreate;
}

export interface ApiAddDeviceV2V2ConfPostRequest {
    deviceCreate: DeviceCreate;
}

export interface ApiGetClientListV2V2ClientGetRequest {
    page?: number | null;
    pageSize?: number | null;
}

export interface ApiGetClientV2V2ClientClientIdGetRequest {
    clientId: string;
}

export interface ApiGetConfByClientV2V2ConfClientClientIdGetRequest {
    clientId: string;
    page?: number | null;
    pageSize?: number | null;
}

export interface ApiGetConfListv2V2ConfGetRequest {
    page?: number | null;
    pageSize?: number | null;
}

export interface ApiPatchClientV2V2ClientClientIdPatchRequest {
    clientId: string;
    clientUpdate: ClientUpdate;
}

export interface ApiPatchDeviceV2V2ConfDeviceIdPatchRequest {
    deviceId: string;
    deviceUpdate: DeviceUpdate;
}

/**
 * 
 */
export class ManagementOauthApi extends runtime.BaseAPI {

    /**
     * Add a client to the database.
     * Api Add Client V2
     */
    async apiAddClientV2V2ClientPostRaw(requestParameters: ApiAddClientV2V2ClientPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['clientCreate'] == null) {
            throw new runtime.RequiredError(
                'clientCreate',
                'Required parameter "clientCreate" was null or undefined when calling apiAddClientV2V2ClientPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/client`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCreateToJSON(requestParameters['clientCreate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Add a client to the database.
     * Api Add Client V2
     */
    async apiAddClientV2V2ClientPost(requestParameters: ApiAddClientV2V2ClientPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiAddClientV2V2ClientPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permet d\'ajouter un équipement dans la base de données.
     * Api Add Device V2
     */
    async apiAddDeviceV2V2ConfPostRaw(requestParameters: ApiAddDeviceV2V2ConfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceCreate'] == null) {
            throw new runtime.RequiredError(
                'deviceCreate',
                'Required parameter "deviceCreate" was null or undefined when calling apiAddDeviceV2V2ConfPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/conf`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceCreateToJSON(requestParameters['deviceCreate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet d\'ajouter un équipement dans la base de données.
     * Api Add Device V2
     */
    async apiAddDeviceV2V2ConfPost(requestParameters: ApiAddDeviceV2V2ConfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiAddDeviceV2V2ConfPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of clients with optional pagination.
     * Api Get Client List V2
     */
    async apiGetClientListV2V2ClientGetRaw(requestParameters: ApiGetClientListV2V2ClientGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};
        
        if (this.configuration && this.configuration.accessToken) {
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/client`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get list of clients with optional pagination.
     * Api Get Client List V2
     */
    async apiGetClientListV2V2ClientGet(requestParameters: ApiGetClientListV2V2ClientGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetClientListV2V2ClientGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific client by ID.
     * Api Get Client V2
     */
    async apiGetClientV2V2ClientClientIdGetRaw(requestParameters: ApiGetClientV2V2ClientClientIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling apiGetClientV2V2ClientClientIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/client/{client_id}`;
        urlPath = urlPath.replace(`{${"client_id"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get a specific client by ID.
     * Api Get Client V2
     */
    async apiGetClientV2V2ClientClientIdGet(requestParameters: ApiGetClientV2V2ClientClientIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetClientV2V2ClientClientIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get devices for a specific client with optional pagination.
     * Api Get Conf By Client V2
     */
    async apiGetConfByClientV2V2ConfClientClientIdGetRaw(requestParameters: ApiGetConfByClientV2V2ConfClientClientIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling apiGetConfByClientV2V2ConfClientClientIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/conf/client/{client_id}`;
        urlPath = urlPath.replace(`{${"client_id"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get devices for a specific client with optional pagination.
     * Api Get Conf By Client V2
     */
    async apiGetConfByClientV2V2ConfClientClientIdGet(requestParameters: ApiGetConfByClientV2V2ConfClientClientIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetConfByClientV2V2ConfClientClientIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Récupère la liste des devices dans la BDD.  Supports optional pagination via query parameters. Returns simple array by default, paginated response when both page and page_size provided.
     * Api Get Conf Listv2
     */
    async apiGetConfListv2V2ConfGetRaw(requestParameters: ApiGetConfListv2V2ConfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/conf`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Récupère la liste des devices dans la BDD.  Supports optional pagination via query parameters. Returns simple array by default, paginated response when both page and page_size provided.
     * Api Get Conf Listv2
     */
    async apiGetConfListv2V2ConfGet(requestParameters: ApiGetConfListv2V2ConfGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetConfListv2V2ConfGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a client.
     * Api Patch Client V2
     */
    async apiPatchClientV2V2ClientClientIdPatchRaw(requestParameters: ApiPatchClientV2V2ClientClientIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling apiPatchClientV2V2ClientClientIdPatch().'
            );
        }

        if (requestParameters['clientUpdate'] == null) {
            throw new runtime.RequiredError(
                'clientUpdate',
                'Required parameter "clientUpdate" was null or undefined when calling apiPatchClientV2V2ClientClientIdPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/client/{client_id}`;
        urlPath = urlPath.replace(`{${"client_id"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ClientUpdateToJSON(requestParameters['clientUpdate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update a client.
     * Api Patch Client V2
     */
    async apiPatchClientV2V2ClientClientIdPatch(requestParameters: ApiPatchClientV2V2ClientClientIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiPatchClientV2V2ClientClientIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * modification d\'un device
     * Api Patch Device V2
     */
    async apiPatchDeviceV2V2ConfDeviceIdPatchRaw(requestParameters: ApiPatchDeviceV2V2ConfDeviceIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiPatchDeviceV2V2ConfDeviceIdPatch().'
            );
        }

        if (requestParameters['deviceUpdate'] == null) {
            throw new runtime.RequiredError(
                'deviceUpdate',
                'Required parameter "deviceUpdate" was null or undefined when calling apiPatchDeviceV2V2ConfDeviceIdPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/conf/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceUpdateToJSON(requestParameters['deviceUpdate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * modification d\'un device
     * Api Patch Device V2
     */
    async apiPatchDeviceV2V2ConfDeviceIdPatch(requestParameters: ApiPatchDeviceV2V2ConfDeviceIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiPatchDeviceV2V2ConfDeviceIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
